var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 162.04 118.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#000;stroke-miterlimit:10;stroke-width:1.67px;}.cls-2{fill:#da00c6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.08,68.05A58.32,58.32,0,1,1,54.25,91.7L3.16,98.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.22,48.73A12.19,12.19,0,0,1,80.05,41c7.17-4.17,16.43-1.2,20.48,6l1.92,3.43,2-3.39c4.18-7.17,13.48-10,20.58-5.68a12.15,12.15,0,0,1,5.69,7.87c3.06,12.71-25.64,40.2-28.5,42.9v.23l-.12-.11-.12.11v-.23C99.15,89.38,70.94,61.39,74.22,48.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart2);
export default __webpack_public_path__ + "static/media/heart2.94e2c631dba713307ff174455b725d52.svg";
export { ForwardRef as ReactComponent };